import Vue from "vue";
import { AxiosResponse } from "axios";

interface LoginForm {
  account: string;
  password: string;
}

interface Update {
  avatar?: boolean;
  data?: boolean;
  force?: boolean;
}

interface User {
  isLogin?: boolean;
  token?: string;
  account?: string;
  email?: string;
  name?: string;
  telephone?: string;
  address?: string;
  company?: string;
  taxId?: string;
  thirdPartyGoogle?: string;
  thirdPartyFacebook?: string;
  avatar?: string;
  hasAvatar: boolean;
  avatarUpdated?: number;
  updated?: number;
  notification?: boolean;
}

const getDefaultUser = () => {
  return {
    isLogin: false,
    token: "",
    account: "",
    email: "",
    name: "",
    telephone: "",
    address: "",
    company: "",
    taxId: "",
    thirdPartyGoogle: "",
    thirdPartyFacebook: "",
    avatar: "/assets/ic/header/ic_header_heads_default2.svg",
    hasAvatar: false,
    avatarUpdated: 0,
    updated: 0,
    notification: false
  } as User;
};

const user = {
  namespaced: true,
  state: {
    isLogin: false,
    token: "",
    account: "",
    email: "",
    name: "",
    telephone: "",
    address: "",
    company: "",
    taxId: "",
    thirdPartyGoogle: "",
    thirdPartyFacebook: "",
    avatar: "/assets/ic/header/ic_header_heads_default2.svg",
    hasAvatar: false,
    avatarUpdated: 0,
    updated: 0,
    notification: false
  } as User,
  mutations: {
    setUser(state: User, options: User) {
      Vue.set(state, "account", options.account);
      Vue.set(state, "address", options.address);
      Vue.set(state, "company", options.company);
      Vue.set(state, "email", options.email);
      Vue.set(state, "name", options.name);
      Vue.set(state, "taxId", options.taxId);
      Vue.set(state, "telephone", options.telephone);
      Vue.set(state, "thirdPartyFacebook", options.thirdPartyFacebook);
      Vue.set(state, "thirdPartyGoogle", options.thirdPartyGoogle);
      Vue.set(state, "notification", options.notification);
      Vue.set(state, "updated", options.updated);
      /*
      state.account = options.account;
      state.address = options.address;
      state.company = options.company;
      state.email = options.email;
      state.name = options.name;
      state.taxId = options.taxId;
      state.telephone = options.telephone;
      */
      //Object.assign(state, options);
    },
    setAvatar(state: User, avatar: string) {
      Vue.set(state, "avatar", avatar);
      Vue.set(state, "avatarUpdated", Date.now());
    },
    setHasAvatar(state: User, hasAvatar: boolean) {
      Vue.set(state, "hasAvatar", hasAvatar);
    },
    setUserName(state: User, name: string) {
      Vue.set(state, "name", name);
      //state.name = name;
    },
    setUserNotification(state: User, enabled: boolean) {
      Vue.set(state, "notification", enabled);
      Vue.cookies.set("notification", enabled);
    },
    setLogin(state: User, isLogin: boolean) {
      Vue.set(state, "isLogin", isLogin);
      //state.isLogin = isLogin;
    },
    clearUser(state: User) {
      Object.assign(state, getDefaultUser());
      //Vue.prototype.$forceUpdate();
    },
    checkCookie(state: User) {
      if (Vue.cookies.get("token")) {
        Vue.set(state, "isLogin", true);
        Vue.set(state, "token", Vue.cookies.get("token"));
        Vue.set(
          state,
          "notification",
          Vue.cookies.get("notification") === "true"
        );
      } else {
        Vue.set(state, "isLogin", false);
        Vue.set(state, "token", "");
        Vue.set(state, "notification", false);
      }
      if (Vue.cookies.get("name"))
        Vue.set(state, "name", Vue.cookies.get("name"));
    }
  },
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getUser(context: any, force: boolean) {
      const delta = Date.now() - context.state.updated;
      if (delta < 3600 * 1000 && !force) return;
      const res = await Vue.prototype.$http.get("members");
      const userData = res.data;
      userData.account = userData.member.account;
      userData.thirdPartyGoogle = userData.member.thirdPartyGoogle;
      userData.thirdPartyFacebook = userData.member.thirdPartyFacebook;
      userData.notification = userData.member.notification;
      userData.updated = Date.now();
      context.commit("setUser", userData as User);
      //Vue.prototype.$forceUpdate();
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getAvatar(context: any, force: boolean) {
      if (!context.state.isLogin) return;
      const delta = Date.now() - context.state.avatarUpdated;
      if (delta < 3600 * 1000 && !force) return;
      await Vue.prototype.$http
        .get("members/avatar")
        .then((res: AxiosResponse) => {
          context.commit("setAvatar", res.data);
          context.commit("setHasAvatar", true);
        })
        .catch(() => {
          context.commit("setHasAvatar", false);
          context.commit(
            "setAvatar",
            "/assets/ic/header/ic_header_heads_default2.svg"
          );
        });
    }
  }
};

export default user;
